var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket-menu"},[_c('router-link',{attrs:{"to":"/basket"}},[_c('img',{attrs:{"src":_vm.header ? _vm.headerIcon : _vm.defaultIcon,"alt":"Корзина"}})]),(_vm.getAmountOfProducts)?_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(_vm.getAmountOfProducts))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }